"use client"

import React, { useEffect, useState } from "react"
import { motion } from "framer-motion"
//test and push
interface ProgressPillProps {
  value: number
}

export default function ProgressPill({ value }: ProgressPillProps) {
  const [mounted, setMounted] = useState(false)
  const clamped = Math.max(0, Math.min(100, Math.round(value)))
  const bubbleWidth = 56

  useEffect(() => {
    setMounted(true)
  }, [])

  return (
    <div className="w-full md:px-7">
      <div className="relative">
        {/* Track */}
        <div className="h-3 rounded-full bg-secondary/30 overflow-hidden backdrop-blur-sm">
          {/* Fill bar */}
          <motion.div
            className="h-full rounded-full bg-gradient-to-r from-primary to-primary/80"
            initial={{ width: 0 }}
            animate={{ width: `${clamped}%` }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          />
        </div>

        {/* Floating bubble */}
        <motion.div
          className="absolute -top-3 flex items-center justify-center pointer-events-none"
          style={{
            width: bubbleWidth,
            x: "-50%",
          }}
          initial={{ left: 0, opacity: 0 }}
          animate={{
            left: `${clamped}%`,
            opacity: mounted ? 1 : 0
          }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        >
          <div
            className="h-7 rounded-full flex items-center justify-center text-primary-foreground text-[11px] font-bold shadow-lg border-2 border-background bg-primary"
            style={{ width: bubbleWidth }}
          >
            {clamped}%
          </div>
        </motion.div>
      </div>
    </div>
  )
}
